import type { Menus } from '~/types';

export default {
  menus: {
    // home: {
    //   HU: 'Főoldal',
    //   EN: 'Home',
    //   RS: 'Početna stranica',
    //   to: '/',
    // },

    tickets: {
      HU: 'Jegyek',
      EN: 'Tickets',
      RS: 'Ulaznice',
      to: '/tickets',
    },
    musicartists: {
      HU: 'Fellépők',
      EN: 'Artists',
      RS: 'Izvođači',
      to: '/artists',
    },
    programmes: {
      HU: 'Programok',
      EN: 'Programmes',
      RS: 'Programi',
      to: '/program',
      subitems: {
        lineup: {
          HU: 'Zenei Program',
          EN: 'Music Program',
          RS: 'Muzički Programi',
          to: '/program',
        },
        daily: {
          HU: 'Nappali Programok',
          EN: 'Daytime Programs',
          RS: 'Dnevni Programi',
          to: '/program/daytime',
        },
        kids: {
          HU: 'Gyerekprogramok',
          EN: "Children's Programs",
          RS: 'Dečiji Programi',
          to: '/program/kids',
        },
      },
    },
    // programs: {
    // HU: 'Programok',
    // EN: 'Programs',
    // RS: 'Programi',
    //   to: '/music-program',
    //   subitems: {
    //     music: {
    //       HU: 'Zenei program',
    //       EN: 'Music program',
    //       RS: 'Muzički program',
    //       to: '/music-program',
    //     },
    //     musicartists: {
    //       HU: 'Fellépők',
    //       RS: 'Izvođači',
    //       to: '/artists',
    //     },
    //     daily: {
    //       HU: 'Nappali program',
    //       RS: 'Dnevni programi',
    //       to: '/daily',
    //     },
    //     dailyartists: {
    //       HU: 'Nappali fellépők',
    //       RS: 'Učesnici dnevnog programa',
    //       to: '/daily-artists',
    //     },
    //     kids: {
    //       HU: 'Gyerekprogram',
    //       to: '/kids-program',
    //     },
    //   },
    // },
    map: {
      HU: 'Térkép',
      EN: 'Map',
      RS: 'Mapa',
      to: '/map',
    },
    info: {
      HU: 'Info',
      EN: 'Info',
      RS: 'Info',
      to: '/about',
      subitems: {
        about: {
          HU: 'Rólunk',
          EN: 'Info',
          RS: 'Info',
          to: '/about',
        },
        rules: {
          HU: 'Házirend',
          EN: 'House rules',
          RS: 'Kućni red',
          to: '/about/rules',
        },
        faq: {
          HU: 'GYIK',
          EN: 'FAQ',
          RS: 'FAQ',
          to: '/about/faq',
        },
        privacy: {
          to: '/privacy',
          HU: 'Adatkezelési tájékoztató',
          EN: 'Privacy Policy',
          RS: 'Analitika',
        },
      },

    },
    camps: {
      HU: 'Alkotótáborok',
      EN: 'Creative Camps',
      RS: 'Kreativni kampovi',
      to: '/camps',
    },
    // partners: {
    //   HU: 'Partnerek',
    //   EN: 'Partners',
    //   RS: 'Partneri',
    //   to: '/partners',
    // },
    galery: {
      HU: 'Galéria',
      EN: 'Gallery',
      RS: 'Galerija',
      to: '/gallery',
    },
    press: {
      HU: 'Press',
      EN: 'Press',
      RS: 'Press',
      to: '/press',
    },
    contact: {
      HU: 'Kapcsolat',
      EN: 'Contact',
      RS: 'Kontakt',
      to: '/contact',
    },
  },
} as Menus;
